<div>
  <div class="grHead justify-content-between align-items-center pt-4">
    <h2 class="boldLIght towLineHead">
          <strong><span class="f-32">View on map</span></strong>
    </h2>
    <div>
      <img src="../../../assets/dds-images/dds2_close-x.svg" alt="" class="closeMap" (click)="onCloseClick()">
    </div>
  </div>
  <div class="storeMap">
    <google-map id="map" #myGoogleMap height="455px" width="100%" [center]="center" [zoom]="zoom"
        (mapClick)="addMarker($event)">
        <map-marker #markerElem="mapMarker" [position]="markers.position" [title]="markers.title"
            [options]="markers.options" (mapDragend)="addMarker($event)">
        </map-marker>
    </google-map>
  </div>
</div>
